import NoSuppliers from './NoSuppliers';
export default NoSuppliers;
